import VirtualControlPad, {padButtons, padStates} from "../managers/VirtualControlPad";

export default class Input extends Phaser.Scene {

    constructor() {
        super({ key: 'Input', active: true });
    }
  
    preload(): void {


    }

    create(): void{
        this.input.keyboard.on('keydown_ESC', (e)=>{
          e.stopImmediatePropagation();
          if(e.repeat) return;
          VirtualControlPad.usingGamepad = false;
          VirtualControlPad.setStatus(padButtons.START,padStates.CLICK)
        });
        this.input.keyboard.on('keyup_ESC', (e)=>{
          e.stopImmediatePropagation();
          VirtualControlPad.setStatus(padButtons.START,padStates.RELEASE)
        });
    
        this.input.keyboard.on('keydown_LEFT', (e)=>{
          e.stopImmediatePropagation();
          if(e.repeat) return;
          VirtualControlPad.usingGamepad = false;
          VirtualControlPad.setStatus(padButtons.LEFT,padStates.CLICK)
        });
        this.input.keyboard.on('keyup_LEFT', (e)=>{
          e.stopImmediatePropagation();
          VirtualControlPad.setStatus(padButtons.LEFT,padStates.RELEASE)
        });
        this.input.keyboard.on('keydown_A', (e)=>{
          e.stopImmediatePropagation();
          if(e.repeat) return;
          VirtualControlPad.usingGamepad = false;
          VirtualControlPad.setStatus(padButtons.LEFT,padStates.CLICK)
        });
        this.input.keyboard.on('keyup_A', (e)=>{
          e.stopImmediatePropagation();
          VirtualControlPad.setStatus(padButtons.LEFT,padStates.RELEASE)
        });

        this.input.keyboard.on('keydown_RIGHT', (e)=>{
          e.stopImmediatePropagation();
          if(e.repeat) return;
          VirtualControlPad.usingGamepad = false;
          VirtualControlPad.setStatus(padButtons.RIGHT,padStates.CLICK)
        });
        this.input.keyboard.on('keyup_RIGHT', (e)=>{
          e.stopImmediatePropagation();
          VirtualControlPad.setStatus(padButtons.RIGHT,padStates.RELEASE)
        });
        this.input.keyboard.on('keydown_D', (e)=>{
          e.stopImmediatePropagation();
          if(e.repeat) return;
          VirtualControlPad.usingGamepad = false;
          VirtualControlPad.setStatus(padButtons.RIGHT,padStates.CLICK)
        });
        this.input.keyboard.on('keyup_D', (e)=>{
          e.stopImmediatePropagation();
          VirtualControlPad.setStatus(padButtons.RIGHT,padStates.RELEASE)
        });

        this.input.keyboard.on('keydown_UP', (e)=>{
          e.stopImmediatePropagation();
          if(e.repeat) return;
          VirtualControlPad.usingGamepad = false;
          VirtualControlPad.setStatus(padButtons.UP,padStates.CLICK)
        });
        this.input.keyboard.on('keyup_UP', (e)=>{
          e.stopImmediatePropagation();
          VirtualControlPad.setStatus(padButtons.UP,padStates.RELEASE)
        });
        this.input.keyboard.on('keydown_W', (e)=>{
          e.stopImmediatePropagation();
          if(e.repeat) return;
          VirtualControlPad.usingGamepad = false;
          VirtualControlPad.setStatus(padButtons.UP,padStates.CLICK)
        });
        this.input.keyboard.on('keyup_W', (e)=>{
          e.stopImmediatePropagation();
          VirtualControlPad.setStatus(padButtons.UP,padStates.RELEASE)
        });

        this.input.keyboard.on('keydown_DOWN', (e)=>{
          e.stopImmediatePropagation();
          if(e.repeat) return;
          VirtualControlPad.usingGamepad = false;
          VirtualControlPad.setStatus(padButtons.DOWN,padStates.CLICK)
        });
        this.input.keyboard.on('keyup_DOWN', (e)=>{
          e.stopImmediatePropagation();
          VirtualControlPad.setStatus(padButtons.DOWN,padStates.RELEASE)
        });
        this.input.keyboard.on('keydown_S', (e)=>{
          e.stopImmediatePropagation();
          if(e.repeat) return;
          VirtualControlPad.usingGamepad = false;
          VirtualControlPad.setStatus(padButtons.DOWN,padStates.CLICK)
        });
        this.input.keyboard.on('keyup_S', (e)=>{
          e.stopImmediatePropagation();
          VirtualControlPad.setStatus(padButtons.DOWN,padStates.RELEASE)
        });
    
        this.input.keyboard.on('keydown_Z', (e)=>{
          e.stopImmediatePropagation();
          if(e.repeat) return;
          VirtualControlPad.usingGamepad = false;
          VirtualControlPad.setStatus(padButtons.A,padStates.CLICK)
        });
        this.input.keyboard.on('keyup_Z', (e)=>{
          e.stopImmediatePropagation();
          VirtualControlPad.setStatus(padButtons.A,padStates.RELEASE)
        });

        this.input.keyboard.on('keydown_SPACE', (e)=>{
          e.stopImmediatePropagation();
          if(e.repeat) return;
          VirtualControlPad.usingGamepad = false;
          VirtualControlPad.setStatus(padButtons.A,padStates.CLICK)
        });
        this.input.keyboard.on('keyup_SPACE', (e)=>{
          e.stopImmediatePropagation();
          VirtualControlPad.setStatus(padButtons.A,padStates.RELEASE)
        });

        this.input.keyboard.on('keydown_X', (e)=>{
          e.stopImmediatePropagation();
          if(e.repeat) return;
          VirtualControlPad.usingGamepad = false;
          VirtualControlPad.setStatus(padButtons.B,padStates.CLICK)
        });
        this.input.keyboard.on('keyup_X', (e)=>{
          e.stopImmediatePropagation();
          VirtualControlPad.setStatus(padButtons.B,padStates.RELEASE)
        });

        this.input.gamepad.on('down',  (pad, button, index)=>{
            switch(button.index){
                case 1:
                    VirtualControlPad.setStatus(padButtons.A,padStates.CLICK);
                break;
                case 2:
                    VirtualControlPad.setStatus(padButtons.B,padStates.CLICK);
                break;
                case 9:
                    VirtualControlPad.setStatus(padButtons.START,padStates.CLICK);
                break;
            }
            VirtualControlPad.usingGamepad = true;
          });
          this.input.gamepad.on('up',  (pad, button, index)=>{
            switch(button.index){
                case 1:
                    VirtualControlPad.setStatus(padButtons.A,padStates.RELEASE);
                break;
                case 2:
                    VirtualControlPad.setStatus(padButtons.B,padStates.RELEASE);
                break;
                case 9:
                    VirtualControlPad.setStatus(padButtons.START,padStates.RELEASE);
                break;
            }
          });
    }

    preupdate(): void{
    }

    update(time, delta){
        VirtualControlPad.onUpdate(delta);

        const padButtons = VirtualControlPad._buttons;
        const padStates = VirtualControlPad._status;

        if (this.input.gamepad.total !== 0){
            const pad = this.input.gamepad.getPad(0);
      
            if (pad.axes.length)
            {
                const axisH = pad.axes[0].getValue();
                if(axisH > 0 && VirtualControlPad.isNone(padButtons.RIGHT)){
                  VirtualControlPad.setStatus(padButtons.RIGHT,padStates.CLICK);
                  VirtualControlPad.setStatus(padButtons.LEFT,padStates.RELEASE);
                  VirtualControlPad.DPadActive = true;
                  VirtualControlPad.usingGamepad = true;
                }else if(axisH < 0 && VirtualControlPad.isNone(padButtons.LEFT)){
                  VirtualControlPad.setStatus(padButtons.LEFT,padStates.CLICK);
                  VirtualControlPad.setStatus(padButtons.RIGHT,padStates.RELEASE);
                  VirtualControlPad.DPadActive = true;
                  VirtualControlPad.usingGamepad = true;
                }

                const axisV = pad.axes[1].getValue();
                if(axisV < 0 && VirtualControlPad.isNone(padButtons.UP)){
                  VirtualControlPad.setStatus(padButtons.UP,padStates.CLICK);
                  VirtualControlPad.setStatus(padButtons.DOWN,padStates.RELEASE);
                  VirtualControlPad.DPadActive = true;
                  VirtualControlPad.usingGamepad = true;
                }else if(axisV > 0 && VirtualControlPad.isNone(padButtons.DOWN)){
                  VirtualControlPad.setStatus(padButtons.DOWN,padStates.CLICK);
                  VirtualControlPad.setStatus(padButtons.UP,padStates.RELEASE);
                  VirtualControlPad.DPadActive = true;
                  VirtualControlPad.usingGamepad = true;
                }

                if(axisH === 0 && axisV === 0 && VirtualControlPad.DPadActive &&
                    (
                        VirtualControlPad.isHeld(padButtons.UP) || VirtualControlPad.isHeld(padButtons.DOWN) ||
                        VirtualControlPad.isHeld(padButtons.LEFT) || VirtualControlPad.isHeld(padButtons.RIGHT)
                    )
                ) {
                  VirtualControlPad.setStatus(padButtons.UP,padStates.RELEASE);
                  VirtualControlPad.setStatus(padButtons.DOWN,padStates.RELEASE);
                  VirtualControlPad.setStatus(padButtons.RIGHT,padStates.RELEASE);
                  VirtualControlPad.setStatus(padButtons.LEFT,padStates.RELEASE);
                  VirtualControlPad.DPadActive = false;
                }
            }
          }
    }
  
  }